import { render, staticRenderFns } from "./StepOrderType.vue?vue&type=template&id=6c47699c&scoped=true&"
import script from "./StepOrderType.vue?vue&type=script&lang=ts&"
export * from "./StepOrderType.vue?vue&type=script&lang=ts&"
import style0 from "./StepOrderType.vue?vue&type=style&index=0&id=6c47699c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47699c",
  null
  
)

export default component.exports